export default __webpack_public_path__ + "static/TGR-2fb43b4c6c6d6b6a37a2f0e04d0bce52.png";